module.exports = __webpack_public_path__ + "img/AI (6).b998e950.png";